import request from 'config/apiConfig';

const setupEmployeeProfile = (businessEmail: string) => {
  return request.post('/profile/employees/profile', { businessEmail });
};

export const getUserData = () => {
  return request
    .get('/partner/accounts/me')
    .then(account => {
      const setupRequired = Boolean(account.data?._links?.['profile:setup']);
      const profileSetup = setupRequired ? setupEmployeeProfile(account.data.emailAddress.address) : Promise.resolve();

      return profileSetup.then(() => {
        return request.get('/profile/employees/profile').then(profile => {
          return request.get(`/partner/marketers/${profile.data.marketerId}`).then((marketer: any) => {
            return {
              account: account.data,
              profile: profile.data,
              marketer: marketer.data
              // cover: cover?.data,
              // display: display?.data,
              // logo: logo?.data
            };
            // return Promise.all([
            //   request.get(profile.data._links['content:cover'].href).catch(error => {
            //     if (error.status === 404) {
            //       return null;
            //     } else {
            //       throw error;
            //     }
            //   }),
            //   request.get(profile.data._links['content:display'].href).catch(error => {
            //     if (error.status === 404) {
            //       return null;
            //     } else {
            //       throw error;
            //     }
            //   }),
            //   request.get(marketer.data._links['content:logo'].href).catch(error => {
            //     if (error.status === 404) {
            //       return null;
            //     } else {
            //       throw error;
            //     }
            //   })
            // ]).then(([cover, display, logo]) => {
            //   return {
            //     account: account.data,
            //     profile: profile.data,
            //     marketer: marketer.data,
            //     cover: cover?.data,
            //     display: display?.data,
            //     logo: logo?.data
            //   };
            // });
          });
        });
      });
    })
    .catch(error => {
      return error;
    });
};
